var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogoBrandCompetition = function SvgLogoBrandCompetition(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 245.248,
    height: 45,
    viewBox: "0 0 245.248 45",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2119",
    "data-name": "Gruppe 2119",
    transform: "translate(-54.499 -6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2113",
    "data-name": "Gruppe 2113",
    transform: "translate(54.499 6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2112",
    "data-name": "Gruppe 2112",
    transform: "translate(62.459 5.964)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10384",
    "data-name": "Pfad 10384",
    d: "M216.5,13.98c-5.059,0-9.917,1.783-13,4.767-3.021,2.925-4.554,6.955-4.554,11.976C198.941,43.595,210.055,47,215.932,47A39.215,39.215,0,0,0,227.5,45.074V29.2l-9.076,0V39.719a4.526,4.526,0,0,1-1.975.371c-1.281,0-7.675-.44-7.675-9.122,0-6.775,2.738-10.069,8.564-10.069a28.135,28.135,0,0,1,7.788,1.594l.992-6.86A32.586,32.586,0,0,0,216.5,13.98Z",
    transform: "translate(-44.711 -13.98)",
    fill: "#ed7100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10385",
    "data-name": "Pfad 10385",
    d: "M149.055,14.546h-9.448L127.844,45.821l9.482,0,1.642-4.867h10.726l1.641,4.867,9.485,0ZM140.933,34.4l3.4-9.9,3.4,9.9Z",
    transform: "translate(-80.151 -13.698)",
    fill: "#ed7100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10386",
    "data-name": "Pfad 10386",
    d: "M184.76,14.546l-2.937,12.448c-.3,1.286-1.77,7.92-1.8,8.113-.031-.192-1.5-6.826-1.8-8.113L175.28,14.546h-8.469l-2.934,12.448c-.3,1.286-1.773,7.92-1.8,8.113-.034-.192-1.5-6.826-1.806-8.113l-2.934-12.448H148.1L156.6,45.815h9.855L169.068,35.7c.333-1.286,1.943-7.917,1.978-8.111.036.194,1.644,6.825,1.976,8.111l2.616,10.111H185.5l8.492-31.269Z",
    transform: "translate(-70.053 -13.698)",
    fill: "#ed7100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10387",
    "data-name": "Pfad 10387",
    d: "M198.187,14.546H188.74L176.975,45.821l9.485,0L188.1,40.95h10.728l1.639,4.867,9.485,0ZM190.066,34.4l3.4-9.9,3.4,9.9Z",
    transform: "translate(-55.66 -13.698)",
    fill: "#ed7100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10388",
    "data-name": "Pfad 10388",
    d: "M137.779,14.546H113.4v7.291H120.9V45.815h9.476V21.837h7.4Z",
    transform: "translate(-87.352 -13.698)",
    fill: "#ed7100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10389",
    "data-name": "Pfad 10389",
    d: "M121.352,36.563c0-6.473-5.735-8.41-9.529-9.69l-1.8-.6c-2.438-.831-4.293-1.609-4.185-3.427.085-1.42,1.356-2.113,3.886-2.113a34.167,34.167,0,0,1,8.239,1.517l1.023-6.667a28.291,28.291,0,0,0-9.514-1.591c-3.454,0-8.168.578-11,3.34a8.512,8.512,0,0,0-2.449,6.358c0,5.849,5.194,7.791,8.988,9.206l3.285,1.242c1.97.749,3.524,1.341,3.325,3.444-.226,2.357-3.048,2.612-4.25,2.612-2.454,0-8.189-1.589-10.311-2.185l-1.028,6.959a53.274,53.274,0,0,0,10.4,2.021c5.66.243,9.784-.831,12.225-3.175a9.624,9.624,0,0,0,2.7-7.249Z",
    transform: "translate(-96.016 -13.976)",
    fill: "#ed7100"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10390",
    "data-name": "Pfad 10390",
    d: "M54.566,33.354c1.293-9.727,18.917-18.7,30.428-23.222.238-.09.5-.237.721-.017a.408.408,0,0,1,.039.515c-.977,1.473-10.483,15.424-13.2,25.315-.761,2.747-1.572,7.962.692,12.291a.506.506,0,0,1,.064.522c-.151.236-.327.227-.673.116,0,0-19.414-5.405-18.07-15.52",
    transform: "translate(-54.499 -10)",
    fill: "#ed7100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10391",
    "data-name": "Pfad 10391",
    d: "M67.4,52.872a.41.41,0,0,1-.039-.515c.977-1.472,10.485-15.424,13.2-25.316.761-2.745,1.572-7.96-.692-12.29,0,0-.216-.287-.064-.522s.325-.228.673-.116c0,0,19.413,5.407,18.067,15.52-1.292,9.729-18.914,18.7-30.426,23.223C67.882,52.947,67.615,53.092,67.4,52.872Z",
    transform: "translate(-48.125 -7.988)",
    fill: "#ed7100"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoBrandCompetition);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo-brand-competition.93c5e3083be5b5b430fd3d16da910e0b.svg";